const invalidNameRegex = /^[^/\\?%*:|"<>@]*$/;

export function isValidName(name) {
  return invalidNameRegex.test(name);
}
